<template>
  <div class="box">
    <div class="serviceMarket w1200">
      <div class="hotTitle">
        <p class="hotTitle_l">服务市场</p>
        <p class="hotTitle_r" @click="getMore">查看更多 ></p>
      </div>
      <div class="serviceMarket_box">
        <div class="serviceMarket_content serviceMarket_content1">
          <p class="content_title" style="font-size:20px">服务资源池</p>
          <p class="content_mesg1">
            服务商服务资源，通过共享设备、共同开发新产品等方式，实现资源互补和合作共赢
          </p>
          <p class="content_btn" @click="openService('seller')">
            发布服务 <i class="el-icon-caret-right"></i>
          </p>
        </div>
        <div class="serviceMarket_content serviceMarket_content4">
          <p class="content_title" style="cursor:pointer;" @click="openServiceList('ZC')">水泵组装</p>
          <p class="content_mesg">Pump assembly</p>
        </div>
      </div>
      <div class="serviceMarket_box2">
        <div class="serviceMarket_content serviceMarket_content2">
          <p class="content_title" style="cursor:pointer;" @click="openServiceList('ZA')">模具制造</p>
          <p class="content_mesg">Mold making</p>
        </div>
        <div class="serviceMarket_content serviceMarket_content3">
          <p class="content_title" style="cursor:pointer;" @click="openServiceList('ZB')">零部件加工</p>
          <p class="content_mesg">Parts processing</p>
        </div>
        <div class="serviceMarket_content serviceMarket_content5">
          <p class="content_title" style="cursor:pointer;" @click="openServiceList('ZD')">物流供需</p>
          <p class="content_mesg">Logistics service</p>
        </div>
        <div class="serviceMarket_content serviceMarket_content6">
          <p class="content_title" style="cursor:pointer;" @click="openServiceList('ZH')">金融服务</p>
          <p class="content_mesg">Finance service</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {findSellerSettledInfo, getNewcurrent} from "../../utils/interface";

export default {
  data() {
    return {};
  },
  methods: {
    getMore() {
      let routeData = this.$router.resolve({
        path: "/serviceList",
      });
      window.open(routeData.href, "_blank");
    },
    openService(type) {
      if (type == "list") {
        let routeData = this.$router.resolve({
          path: "/serviceList",
        });
        window.open(routeData.href, "_blank");
      } else {
/*        let routeData = this.$url.sellerWeb + `#/publishService`;
        this.$cookies.set("authoritiesMess", "sellerCenterService");
        if (routeData != "") {
          window.open(routeData, "_blank");
        }*/

        if (this.$store.state.isLogin) {
          getNewcurrent().then((data) => {
            this.identity = data.identity;
            if (this.identity === 'ENTERPRISE') {
              findSellerSettledInfo({enterPriseId:data.enterpriseUuid}).then((items)=>{
                if(items.data){
                  if(items.data.status=='APPROVE'){
                    this.$cookies.set("authoritiesMess", "sellerCenterService");
                    let routeData = this.$url.sellerWeb + `#/publishService`;
                    if (routeData != "") {
                      window.open(routeData, "_blank");
                    }
                  }else if(items.data.status=='SUBMIT'){
                    this.$message({
                      type: "warning",
                      message: "审核中，请耐心等待！",
                    });
                  }else if(items.data.status=='REJECT'){
                    this.$message({
                      type: "warning",
                      message: "服务商入驻审核拒绝，请重新入驻！",
                    });
                  }
                }else {
                  this.$confirm('请先进行服务商入驻!', '提示', {
                    confirmButtonText: '去入驻',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    this.$router.push({
                      name: "enter",
                    });
                  });
                }
              })
            } else if (this.identity === 'PERSONAL' || this.identity === 'ANONYMOUS') {
              this.$confirm('请先进行企业资质认证!', '提示', {
                confirmButtonText: '去认证',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                window.sessionStorage.setItem("userServeId", "11");
                let routeData = this.$router.resolve({
                  name: "userCenter",
                  params: {
                    userServeId: '11',
                  },
                });
                window.open(routeData.href, "_target");
              });
            }
          })
        }else {
          let routeData = this.$url['sellerWeb'] + `#/publishService`;
          window.open(routeData, "_blank");
          return false;
        }
      }
    },
    openServiceList(oneClass){
      let routeData = this.$router.resolve({
        name: "serviceList",
        params: {classifyOne: oneClass},
      });
      window.open(routeData.href, "_blank");
    },
    openServiceTwoList(oneClass,twoClass){
      let routeData = this.$router.resolve({
        name: "serviceList",
        params: {
          classifyOne: oneClass,
          classifyTwo: twoClass,
        },
      });
      window.open(routeData.href, "_blank");
    }
  },
};
</script>

<style lang="less" scoped>
@import "./style/index.less";
button {
  border: 1px solid #099;
  color: #099;
  width: 140px;
  background: transparent;
}
.box {
  background: #efefef;
  padding: 20px 0 31px;
}
.serviceMarket {
  margin: 0 auto;
  .serviceMarket_box {
    display: grid;
    grid-template-columns: 895px 285px;
    grid-column-gap: 20px;
    color: #fff;
    margin-bottom: 20px;
  }
  .serviceMarket_box2 {
    display: grid;
    grid-template-columns: 285px 285px 285px 285px;
    grid-column-gap: 20px;
    color: #fff;
  }
  .serviceMarket_content {
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 10px 48px;
    height: 161px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .content_title {
      font-size: 26px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 10px;
    }
    .content_mesg1{
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      width: 100%;
    }
    .content_mesg {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
    }
    .content_btn {
      cursor: pointer;
      width: 110px;
      height: 35px;
      border: 1px solid #ffffff;
      color: #fff;
      font-size: 16px;
      text-align: center;
      line-height: 35px;
    }
    ul {
      margin-top: 10px;
      font-weight: 500;
      font-size: 18px;
      line-height: 36px;
      margin-left: 17px;
      li {
        list-style-type: disc;
      }
    }
  }
  .serviceMarket_content1 {
    background: url("../../assets/supplyHome/serverShop1.png") no-repeat;
    background-size: 100%;
    justify-content: space-around;
    align-items: flex-start !important;
  }
  .serviceMarket_content2 {
    background: url("../../assets/supplyHome/serverShop2.png") no-repeat;
    background-size: 100%;
  }
  .serviceMarket_content3 {
    background: url("../../assets/supplyHome/serverShop3.png") no-repeat;
    background-size: 100%;
  }
  .serviceMarket_content4 {
    background: url("../../assets/supplyHome/serverShop4.png") no-repeat;
    background-size: 100%;
  }
  .serviceMarket_content5 {
    background: url("../../assets/supplyHome/serverShop6.png") no-repeat;
    background-size: 100%;
  }
  .serviceMarket_content6 {
    background: url("../../assets/supplyHome/serverShop7.png") no-repeat ;
    background-size: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/serviceMarket.vue